import React, { useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';

function PayNow({
  selectedPayment,
  onPaymentSubmit,
  triggerSubmit,
  paymentType,
}) {
  const { id: paymentMethodId } = selectedPayment;

  useEffect(() => {
    if (!triggerSubmit) return;
    onPaymentSubmit({ paymentMethodId, paymentType });
  }, [onPaymentSubmit, paymentMethodId, paymentType, triggerSubmit]);

  return <div />;
}
PayNow.propTypes = {
  paymentType: string.isRequired,
  selectedPayment: object.isRequired,
  triggerSubmit: bool.isRequired,
  onPaymentSubmit: func.isRequired,
};

export default PayNow;



// WEBPACK FOOTER //
// ./app/components/PaymentHandler/OfflinePaymentShadow/OfflinePaymentShadow.jsx